import { DateTime } from "luxon";
import { trpc } from "../../main/components/trpc.ts";

const formatDate = (date: Date) => DateTime.fromJSDate(date).toFormat("dd/MM/yyyy");

const formatPeriod = (startDate: Date, endDate: Date) => {
  return `${formatDate(startDate)} au ${formatDate(endDate)}`;
};

const formatRate = (rate: number | null) => {
  if (rate === null) {
    return "Non disponible";
  }
  return `${(rate * 100).toLocaleString("fr-FR", {
    maximumFractionDigits: 1,
  })} %`;
};

export default function PeriodComparison() {
  const historyQuery = trpc.stats.getPeriodHistory.useQuery(undefined, {
    staleTime: 5 * 60 * 1000,
  });

  const history = historyQuery.data;

  return (
    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ marginBottom: "0.5rem", fontWeight: "bold", fontSize: "1.25rem" }}>
        Activité et remplissage
      </h2>
      <p style={{ marginBottom: "1rem" }}>
        La première colonne présente les douze derniers mois glissants ; les cinq
        années complètes précédentes sont ensuite affichées (l'année en cours n'apparaît pas).
      </p>
      {historyQuery.isLoading ? <p>Calcul des statistiques...</p> : null}
      {historyQuery.error ? (
        <p role="alert" style={{ color: "#b91c1c", marginTop: "0.5rem" }}>
          Impossible de calculer les statistiques : {historyQuery.error.message}
        </p>
      ) : null}
      {history ? (
        <div style={{ marginTop: "1rem", overflowX: "auto" }}>
          <table style={{ borderCollapse: "collapse", minWidth: "800px", width: "100%" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "0.5rem" }}>Indicateur</th>
                {history.periods.map((period) => (
                  <th
                    key={period.label ?? period.year}
                    style={{ textAlign: "right", padding: "0.5rem" }}
                    title={formatPeriod(period.startDate, period.endDate)}
                  >
                    {period.label ?? period.year}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: "0.5rem" }}>Jours travaillés</td>
                {history.periods.map((period) => (
                  <td key={period.label ?? period.year} style={{ textAlign: "right", padding: "0.5rem" }}>
                    {period.stats.workedDays}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ padding: "0.5rem" }}>Nouveaux patients</td>
                {history.periods.map((period) => (
                  <td key={period.label ?? period.year} style={{ textAlign: "right", padding: "0.5rem" }}>
                    {period.stats.newPatients}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ padding: "0.5rem" }}>Occupation planifiée</td>
                {history.periods.map((period) => (
                  <td key={period.label ?? period.year} style={{ textAlign: "right", padding: "0.5rem" }}>
                    {formatRate(period.stats.plannedFillRate)}
                  </td>
                ))}
              </tr>
              <tr>
                <td style={{ padding: "0.5rem" }}>Remplissage réalisé</td>
                {history.periods.map((period) => (
                  <td key={period.label ?? period.year} style={{ textAlign: "right", padding: "0.5rem" }}>
                    {formatRate(period.stats.realizedFillRate)}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      ) : null}
    </section>
  );
}
